import { createSlice } from '@reduxjs/toolkit';
type IVideoThumbnai = {
  thumbnail: string;
  videoHashId: string;
  decryptionKeys: {
    key: string;
    iv: string;
  };
};
export type decryptedImageState = {
  videos: IVideoThumbnai[];
};

const initialState: decryptedImageState = { videos: [] };

const DecryptedImages = createSlice({
  name: 'decrypted-images',
  initialState: initialState,
  reducers: {
    setVideoDecrytionKey(state, action) {
      const { videoHashId } = action.payload;
      // Check if videoHashId already exists in the videos array
      if (!state.videos.some((video) => video.videoHashId === videoHashId)) {
        state.videos.push(action.payload);
      }
    },
    addVideoThumbnail(state, action) {
      const { videoHashId, thumbnail } = action.payload;
      const existingVideoIndex = state.videos.findIndex((video) => video.videoHashId === videoHashId);
      if (existingVideoIndex !== -1) {
        // If the video already exists, update its thumbnail while preserving other properties
        state.videos[existingVideoIndex] = {
          ...state.videos[existingVideoIndex],
          thumbnail: thumbnail
        };
      }
    }
  }
});

export const getVideoByHashId = (state: decryptedImageState, videoHashId: string): IVideoThumbnai | null => {
  const video = state.videos.find((video: any) => video.videoHashId === videoHashId) || null;
  return video;
};

export const { addVideoThumbnail, setVideoDecrytionKey } = DecryptedImages.actions;
export const decryptedImagesReducer = DecryptedImages.reducer;
